import React from 'react';

import { Glow, Surface } from './GlowCard.styles';

export type GlowCardProps = Omit<React.HTMLAttributes<HTMLElement>, 'children' | 'dangerouslySetInnerHTML'> & {
  /** The glow's stop list, from the top-left corner to the bottom-right: a score band's (`gaugeGradeGlow`) or a hub
   *  area's (`HUB_AREA[area].glow`). */
  glow: string;
  /** The card is a control (it opens something): it draws the shared hover wash, under a pointer cursor. */
  interactive?: boolean;
  /** The element the card is: a div by default, an article for a card that stands on its own, a list item in a list. */
  element?: 'div' | 'article' | 'li';
  children?: React.ReactNode;
};

/**
 * Home's score gauge card surface, for every card drawn as it is (the gauge cards, the Website and Marketing hub
 * cards) and the Top Marketing Assets preview rows (at a row's radius): the gauge card's base, hairline and radius, a
 * glow in the card's colour from the top-left corner fading to grey towards the bottom-right, behind the card's
 * content, and the shared hover wash when the card is a control. A caller lays out what the card holds (its padding,
 * its flex) by styling it.
 */
export const GlowCard = ({
  glow,
  interactive = false,
  element = 'div',
  children,
  ...rest
}: GlowCardProps): React.ReactElement => (
  <Surface as={element} $interactive={interactive} {...rest}>
    <Glow $glow={glow} aria-hidden="true" />
    {children}
  </Surface>
);

export default GlowCard;
